import type { ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogTundish } from "../../../models/CatalogTundish";
import { useCatalogTundishContext } from "../context/CatalogTundishContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setTundish: (tundish: CatalogTundish) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setTundish,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogTundishContext();

  const rows: CatalogTundish[] =
    state.tundishes?.map((tundish: CatalogTundish) => ({
      ...tundish,
    })) || [];

  const columnDefs = [
    {
      field: "TundishName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setTundish,
        data: params.data as CatalogTundish,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "tundishContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
